module.exports = __webpack_public_path__ + "img/spiel essen 2025.5d3a8acd.webp";